import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./Views/HomePage";
import HowToJoin from "./Views/HowToJoin";
import HowToFindUs from "./Views/HowToFindUs";
import NoviceGuidePage from "./Views/NoviceGuidePage";
import MembersPage from "./Views/members/MembersPage";
import MembersVerify from "./Views/members/MembersVerify";
import AdminPage from "./Views/admin/AdminPage";
import { AuthProvider } from "./auth/AuthContext";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/how-to-join" element={<HowToJoin />} />
          <Route path="/how-to-find-us" element={<HowToFindUs />} />
          <Route path="/novice-guide" element={<NoviceGuidePage />} />
          <Route
            path="/secured/members.html"
            element={<Navigate to="/members" replace />}
          />
          <Route path="/members" element={<MembersPage />} />
          <Route path="/members/verify" element={<MembersVerify />} />
          <Route path="/members/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
